import { FC } from "react";
import PlaidIcon from "shared/icons/plaid.svg?react";
import { OnboardingData, View } from "../types";
import { useIntercom } from "react-use-intercom";
import { Card } from "./Card";

export const IDVView: FC<{
  setView: (view: View) => void;
  data: OnboardingData["identity_verification"];
}> = ({ data }) => {
  const intercom = useIntercom();

  return (
    <div className="animate-appear mt-8 flex flex-col items-center justify-center">
      <div style={{ marginBottom: "48px" }}>
        <p className="mb-2 text-center text-2xl font-bold text-content-1000">
          Identity verification
        </p>
        <p className="mb-8 whitespace-pre-line text-center text-sm font-medium text-content-300">
          {`Please verify your identity to continue.${"\n"}This "Start verification" button will open a new tab. Once you've completed the${"\n"}verification, you can close the tab and return here.`}
        </p>
        <div className="px-4">
          <Card
            title="Plaid verification"
            icon={<PlaidIcon height={20} width={55} />}
            buttonText="Start Verification"
            onClick={() => window.open(data.shareable_url)}
          />
        </div>
        <p className="mt-8 whitespace-pre-line text-center text-sm font-medium text-content-300">
          If you have any questions, please contact our{"\n"}
          <span
            className="cursor-pointer text-sm font-bold text-primary-500"
            onClick={() => {
              intercom.show();
            }}
          >
            customer support
          </span>
        </p>
      </div>
    </div>
  );
};
